module.exports = __webpack_public_path__ + "img/sustainabilityPlatinum@2x.b9e8e00.webp";